// Components==============
import React from 'react';
import './ParticipantsCounter.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/pro-solid-svg-icons';
// =========================

export default function ParticipantsCounter({
    registrationsCount,
    maxParticipants,
}) {
    return (
        <div styleName="wrapper">
            <FontAwesomeIcon icon={faUsers} />
            <h3>{registrationsCount}</h3>
            {maxParticipants ? (
                <>
                    <p>/</p>
                    <p>{maxParticipants}</p>
                </>
            ) : null}
        </div>
    );
}
